"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const short_uuid_1 = __importDefault(require("short-uuid"));
const evaluateVarFactoryWithProccessor_1 = __importDefault(require("./evaluateVarFactoryWithProccessor"));
const FirebaseDatabaseCore_1 = __importDefault(require("../FirebaseDatabaseCore"));
const flatAppUser_1 = __importDefault(require("../shared/flatAppUser"));
const createFunctionLogger_1 = __importDefault(require("./createFunctionLogger"));
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const applicationStateActionBuilders_1 = require("../shared/applicationStateActionBuilders");
const serverFunctions_1 = require("../firebase/serverFunctions");
const ensureCorrectProcessorUserInfo_1 = __importDefault(require("../shared/ensureCorrectProcessorUserInfo"));
const setObjectPropByPath_1 = __importDefault(require("../shared/setObjectPropByPath"));
const appStateSelectAppId_1 = __importDefault(require("../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../shared/appStateSelectProjectId"));
const appStateSelectFunctionsDefinitions_1 = __importDefault(require("../shared/appStateSelectFunctionsDefinitions"));
const appStateSelectRoutingStackCurrentPageId_1 = __importDefault(require("../shared/appStateSelectRoutingStackCurrentPageId"));
const appStateSelectBOPageById_1 = __importDefault(require("../shared/appStateSelectBOPageById"));
const appStateSelectFirebaseRealtimeDatabaseCache_1 = __importDefault(require("../shared/appStateSelectFirebaseRealtimeDatabaseCache"));
const appStateSelectRoutingStackCurrentRouteKey_1 = __importDefault(require("../shared/appStateSelectRoutingStackCurrentRouteKey"));
const extractProcessorInfoFromFirebaseRef = async (userRef) => {
    const valuesSnaps = (await Promise.all([
        userRef.child('name').once('value'),
        userRef.child('email').once('value'),
        userRef.child('phone').once('value'),
        userRef.child('photoURL').once('value'),
        userRef.child('customData').once('value'),
    ])).map((snap) => snap.val());
    return (0, ensureCorrectProcessorUserInfo_1.default)({
        name: valuesSnaps[0],
        email: valuesSnaps[1],
        phone: valuesSnaps[2],
        photoURL: valuesSnaps[3],
        customData: valuesSnaps[4],
    });
};
const RootProcessor = ({ store, dispatch, isInDevelopment, getApplicationState, firebase, platformOS, environment, alert, getLanguageLocale, onClearListeners, }) => {
    const processorObject = {
        alert,
        dispatch,
        isInDevelopment,
        userInfo: undefined,
        databaseCore: undefined,
        firebase,
        cloud: {
            rendererLogIn: (params) => (0, serverFunctions_1.rendererLogIn)(firebase.functions())(params),
            rendererUpdateCloudMessageToken: (params) => (0, serverFunctions_1.rendererUpdateCloudMessageToken)(firebase.functions())(params),
            saveMemberData: (params) => (0, serverFunctions_1.saveMemberData)(firebase.functions())(params),
            rendererChangeMyPassword: (params) => (0, serverFunctions_1.rendererChangeMyPassword)(firebase.functions())(params),
            executeAppProcessCloud: (params) => (0, serverFunctions_1.executeAppProcessCloud)(firebase.functions())(params),
            renderForgetPassword: (params) => (0, serverFunctions_1.renderForgetPassword)(firebase.functions())(params),
        },
        userUid: undefined,
        platformOS,
        getLanguageLocale,
        environment,
        arrayIntervals: [],
        arrayOfTimeouts: [],
        appParams: {},
        controlsExtraData: {},
        setAppParam: (paramKey, paramValue) => {
            processorObject.appParams[paramKey] = paramValue;
        },
        setControlExtraData: ({ controlId, path, data }) => {
            const finalPath = path ? `${controlId}.${path}` : controlId;
            processorObject.controlsExtraData = (0, setObjectPropByPath_1.default)(processorObject.controlsExtraData, finalPath.split('.'), data);
        },
        createFunctionLogger: async (functionId) => {
            const appId = (0, appStateSelectAppId_1.default)(store.getState());
            if ((0, valueIsNullOrUndef_1.default)(appId)) {
                throw new Error('To build a funciton logger an app id is required');
            }
            return (0, createFunctionLogger_1.default)({
                appId,
                database: firebase.database(),
                functionId,
                generateId: () => short_uuid_1.default.generate(),
                getTimestamp: () => Date.now(),
            });
        },
        openInputDialog: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateInputdialogContextAction)(params));
        },
        openAlert: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateAlertContextAction)(params));
        },
        openConfirmAlert: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateConfirmAlertContextAction)(params));
        },
        openAdMobInterstitialAds: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppUpdateAdmobInterstitialContextAction)(params));
        },
        setUserUid: (userUid) => {
            processorObject.userUid = userUid;
        },
        setUserInfo: (newUserInfo) => {
            processorObject.userInfo = newUserInfo;
        },
        getIsBottomMenuOpened: () => {
            var _a, _b;
            const appState = store.getState();
            const currentPageId = (0, appStateSelectRoutingStackCurrentPageId_1.default)(appState);
            if (!currentPageId) {
                return false;
            }
            const currentPage = (0, appStateSelectBOPageById_1.default)(currentPageId)(appState);
            if (!currentPage) {
                return false;
            }
            const storeFlag = !!((_a = getApplicationState().bottomMenuFlagsByPage) === null || _a === void 0 ? void 0 : _a[currentPageId]);
            return storeFlag && !!((_b = currentPage.bottomMenuSheet) === null || _b === void 0 ? void 0 : _b.active);
        },
        getAPIInformationById: (apiId) => { var _a; return (_a = store.getState().buildOrders.apis) === null || _a === void 0 ? void 0 : _a[apiId]; },
        getControlInfoById: (controlId) => store.getState().flattedControls[controlId],
        getControlById: (controlId) => {
            const controlInfo = processorObject.getControlInfoById(controlId);
            if (!controlInfo) {
                return null;
            }
            return controlInfo.control;
        },
        setIsSideMenuOpened: (flag) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppSetIsSideMenuOpenedAction)(flag));
        },
        setTransitionSideMenu: (transition) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppSetTransitionSideMenuAction)(transition));
        },
        setIsBottomMenuOpened: (flag) => {
            const appState = store.getState();
            const currentPageId = (0, appStateSelectRoutingStackCurrentPageId_1.default)(appState);
            if (!currentPageId) {
                return;
            }
            dispatch((0, applicationStateActionBuilders_1.buildAppSetIsBottomMenuOpenedAction)({
                flag,
                pageId: currentPageId,
            }));
        },
        cleanListeners: () => {
            var _a;
            processorObject.cleanAllListUpdaters();
            if ((_a = processorObject.databaseCore) === null || _a === void 0 ? void 0 : _a.cleanListeners) {
                processorObject.databaseCore.cleanListeners();
            }
            processorObject.cancelGeoQuery();
            processorObject.clearTimers();
            processorObject.cleanGeoFireListeners();
            processorObject.clearIntervals();
            if (onClearListeners) {
                onClearListeners();
            }
        },
        controlListUpdatersById: {},
        registerListUpdater: (controlId, upcater) => {
            processorObject.controlListUpdatersById[controlId] = upcater;
        },
        cleanAllListUpdaters: () => {
            Object.entries(processorObject.controlListUpdatersById)
                .forEach(([, listUpdater]) => {
                if (listUpdater) {
                    listUpdater.cancel();
                }
            });
            processorObject.controlListUpdatersById = {};
        },
        geoFireListeners: [],
        registerGeoFireListener: ({ path, listener }) => {
            processorObject.geoFireListeners.push({ path, listener });
        },
        cleanGeoFireListeners: () => {
            processorObject.geoFireListeners.forEach(({ path, listener }) => {
                firebase.database().ref(path).off('value', listener);
            });
            processorObject.geoFireListeners = [];
        },
        geoQuerySubscriptions: [],
        cancelGeoQuery: () => {
            processorObject.geoQuerySubscriptions.forEach((subscription) => {
                subscription.cancel();
            });
            processorObject.geoQuerySubscriptions = [];
        },
        registerGeoQuery: (subscriptions) => {
            processorObject.geoQuerySubscriptions = [
                ...processorObject.geoQuerySubscriptions,
                ...subscriptions,
            ];
        },
        arrayTimers: [],
        registerTimer: ({ timer }) => {
            processorObject.arrayTimers.push(timer);
        },
        clearTimers: () => {
            processorObject.arrayTimers.forEach((timer) => {
                clearInterval(timer);
            });
            processorObject.arrayTimers = [];
        },
        controlsRunContext: {},
        getControlRunContext: (controlId) => (controlId
            ? processorObject.controlsRunContext[controlId]
            : undefined),
        setControlRunContext: (controlId, context) => {
            processorObject.controlsRunContext[controlId] = context;
        },
        destroy: () => {
            processorObject.arrayOfTimeouts = [];
            processorObject.cleanListeners();
        },
        registerInterval: (onDone, time) => {
            const interval = setInterval(() => {
                onDone();
            }, time);
            processorObject.arrayIntervals.push(interval);
            return interval;
        },
        registerTimeout: (callback, time) => {
            const timeoutId = short_uuid_1.default.generate();
            processorObject.arrayOfTimeouts.push(timeoutId);
            setTimeout(() => {
                if (!processorObject.arrayOfTimeouts.includes(timeoutId)) {
                    return;
                }
                callback();
            }, time);
        },
        clearIntervals: () => {
            processorObject.arrayIntervals.forEach((interval) => {
                clearInterval(interval);
            });
            processorObject.arrayIntervals = [];
        },
        stopInterval: (interval) => {
            const indexInterval = processorObject.arrayIntervals.findIndex((interId) => interId === interval);
            clearInterval(interval);
            processorObject.arrayIntervals.splice(indexInterval, 1);
        },
        loadFirebaseUserInfo: async () => {
            const state = store.getState();
            const projectId = (0, appStateSelectProjectId_1.default)(state);
            const appId = (0, appStateSelectAppId_1.default)(state);
            if (!appId || !projectId) {
                return;
            }
            let memberValue = {
                name: null,
                email: null,
                phone: null,
                photoURL: null,
                customData: undefined,
            };
            const { currentUser } = processorObject.firebase.auth();
            if (currentUser) {
                const memberRef = processorObject.firebase.database().ref(`projects/${projectId}/apps/${appId}/members/${currentUser.uid}`);
                memberValue = await extractProcessorInfoFromFirebaseRef(memberRef);
            }
            let userValue = {
                name: null,
                email: null,
                phone: null,
                photoURL: null,
            };
            if (currentUser) {
                const userRef = processorObject.firebase.database().ref(`users/${currentUser.uid}`);
                userValue = await extractProcessorInfoFromFirebaseRef(userRef);
            }
            const flattedUser = (currentUser && (0, flatAppUser_1.default)(currentUser)) || undefined;
            processorObject.setUserInfo({
                name: memberValue.name || userValue.name || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.displayName) || null,
                phone: memberValue.phone || userValue.phone || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.phoneNumber) || null,
                photoURL: memberValue.photoURL
                    || userValue.photoURL || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.photoURL) || null,
                customData: memberValue.customData,
                email: memberValue.email || (flattedUser === null || flattedUser === void 0 ? void 0 : flattedUser.email) || null,
            });
        },
        openImageViewer: (params) => {
            dispatch((0, applicationStateActionBuilders_1.buildAppOpenImageViewer)(params));
        },
    };
    let lastRoutingRouteKey = (0, appStateSelectRoutingStackCurrentRouteKey_1.default)(store.getState());
    const routingUnsubscribe = store.subscribe(() => {
        const currentRoutingStackKey = (0, appStateSelectRoutingStackCurrentRouteKey_1.default)(store.getState());
        if (currentRoutingStackKey !== lastRoutingRouteKey) {
            lastRoutingRouteKey = currentRoutingStackKey;
            processorObject.cleanListeners();
        }
    });
    if (!processorObject.databaseCore) {
        processorObject.userInfo = undefined;
        processorObject.databaseCore = (0, FirebaseDatabaseCore_1.default)({
            database: firebase.database(),
            getDatabaseCache: () => (0, appStateSelectFirebaseRealtimeDatabaseCache_1.default)(store.getState()),
        });
    }
    const originalDestroy = processorObject.destroy;
    processorObject.destroy = () => {
        originalDestroy();
        routingUnsubscribe();
    };
    return processorObject;
};
const buildBaseProcessor = ({ store, alert, dispatch, getApplicationState, isInDevelopment, firebase, platformOS, environment, getLanguageLocale, onClearListeners, onReady, requestDevEnvVariableFromNetwork, }) => {
    const rootProcessor = RootProcessor({
        store,
        alert,
        dispatch,
        isInDevelopment,
        getApplicationState,
        firebase,
        platformOS,
        getLanguageLocale,
        environment,
        onClearListeners,
    });
    let unsubscribeFromFirebaseAuthState;
    const baseProcessor = {
        id: short_uuid_1.default.generate(),
        root: rootProcessor,
        requestDevEnvVariableFromNetwork,
        copyProcessorWithContext: (newContext) => {
            const newProcessor = Object.assign(Object.assign({}, baseProcessor), { ovewritedPageParams: newContext });
            return Object.assign(Object.assign({}, newProcessor), { evaluateVarFactory: (0, evaluateVarFactoryWithProccessor_1.default)({
                    store,
                    rootProcessor,
                    processor: newProcessor,
                    functionsDefinitions: (0, appStateSelectFunctionsDefinitions_1.default)(store.getState()),
                }) });
        },
        destroy: () => {
            if (unsubscribeFromFirebaseAuthState) {
                unsubscribeFromFirebaseAuthState();
            }
            rootProcessor.destroy();
        },
    };
    const processor = Object.assign(Object.assign({}, baseProcessor), { evaluateVarFactory: (0, evaluateVarFactoryWithProccessor_1.default)({
            store,
            rootProcessor,
            processor: baseProcessor,
            functionsDefinitions: (0, appStateSelectFunctionsDefinitions_1.default)(store.getState()),
        }) });
    let onReadyCalledBefore = false;
    unsubscribeFromFirebaseAuthState = firebase.auth().onAuthStateChanged(() => {
        rootProcessor.loadFirebaseUserInfo()
            .then(() => {
            if (onReadyCalledBefore) {
                return;
            }
            onReadyCalledBefore = true;
            onReady(processor);
        });
    });
};
const buildApphiveProcessor = ({ store, alert, dispatch, getApplicationState, isInDevelopment, firebase, platformOS, getLanguageLocale, environment, onClearListeners, requestDevEnvVariableFromNetwork, }) => new Promise((resolve) => {
    buildBaseProcessor({
        store,
        alert,
        dispatch,
        firebase,
        getApplicationState,
        isInDevelopment,
        platformOS,
        getLanguageLocale,
        environment,
        onClearListeners,
        onReady: resolve,
        requestDevEnvVariableFromNetwork,
    });
});
exports.default = buildApphiveProcessor;
